//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/TaggedObject.js";
import "../no/SelectNXObject.js";
import "../no/SelectObject.js";
let d=[[[1,"SelectionParent",0,"SelectNXObject",0]],[[["aspectName","aspectType"],"AssignParent",{},2,0],[["aspectType"],"UnassignParent",{},1,0],[["aspectType"],"GetParent",{R_:{aspectParent:"NXObject"}},1,0],[["aspectType","nameAspect"],"AddNameAspect",{},2,0],[["aspectType","source"],"SetNameSource",{},2,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.AME.EngineeringObjectAspectDetailBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.EngineeringObjectAspectDetailBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.EngineeringObjectAspectDetailBuilder.Columns = Object.freeze({
    "Type" : "Type", "Parent" : "Parent", "Name" : "Name"});

SPLM.AME.EngineeringObjectAspectDetailBuilder.NameSource = Object.freeze({
    "Default" : "Default", "NamingRule" : "NamingRule", "UserInput" : "UserInput", "Mapping" : "Mapping"});

export default SPLM;